import { createSlice } from '@reduxjs/toolkit';

export const accountSlice = createSlice({
    name: 'settingsReducer',
    initialState: {
        login: []
    },
    reducers: {
        setLogin: (state, action) => {
            state.login = action.payload;
        },
    },
});

export const {
    setLogin
} = accountSlice.actions;

export default accountSlice.reducer;
